import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { StickyBar } from './components/StickyBar';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { EmotionalBridge } from './components/EmotionalBridge';
import { WhatsIncluded } from './components/WhatsIncluded';
import { ValueStack } from './components/ValueStack';
import { OfferSection } from './components/OfferSection';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full min-h-screen bg-white/60 backdrop-blur-[2px] pt-16" data-id="element-0">
      <StickyBar data-id="element-1" />
      <Hero data-id="element-2" />

      <EmotionalBridge text="Cuando dejás de sentirte deseada," italicPart="algo cambia dentro tuyo." data-id="element-3" />

      <ProblemSection data-id="element-4" />

      <EmotionalBridge text="La atracción no desaparece de golpe." italicPart="Se apaga lentamente." data-id="element-5" />

      <WhatsIncluded data-id="element-6" />

      <ValueStack data-id="element-7" />

      <OfferSection ctaText="Quiero volver a sentirme deseada →" data-id="element-8" />

      <Testimonials data-id="element-9" />

      <Guarantee data-id="element-10" />

      <FAQ data-id="element-11" />

      <FinalCTA data-id="element-12" />
    </div>;
}